"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./utils");
var SpecError = /** @class */ (function (_super) {
    __extends(SpecError, _super);
    function SpecError(message, path) {
        if (path === void 0) { path = []; }
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, SpecError.prototype);
        _this.path = path;
        return _this;
    }
    SpecError.isSpecError = function (e) {
        return e instanceof SpecError;
    };
    SpecError.prototype.buildMessage = function () {
        if (this.path.length === 0) {
            return this.message;
        }
        var pathString = "";
        if (this.path.length === 1) {
            pathString = /^\d+$/.test(this.path[0])
                ? "index [" + this.path[0] + "]"
                : "key " + JSON.stringify(this.path[0]);
        }
        else if (this.path.length > 1) {
            pathString = this.path
                .map(function (key, i) {
                if (/^\d+$/.test(key)) {
                    return "[" + key + "]";
                }
                if (utils_1.safeKeyRegex.test(key)) {
                    return i === 0 ? key : "." + key;
                }
                return "[" + JSON.stringify(key) + "]";
            })
                .join("");
        }
        return this.message + " at " + pathString;
    };
    return SpecError;
}(Error));
exports.SpecError = SpecError;
function mostSpecificError(errors) {
    return errors.sort(function (a, b) {
        if (a.path.length < b.path.length)
            return 1;
        if (a.path.length > b.path.length)
            return -1;
        if (a.message.startsWith("unexpected key") || a.message.startsWith("missing key"))
            return -1;
        if (b.message.startsWith("unexpected key") || b.message.startsWith("missing key"))
            return 1;
        return 0;
    })[0];
}
exports.mostSpecificError = mostSpecificError;
